import { atomFamily } from 'jotai/vanilla/utils';
import type { PrimitiveAtom } from 'jotai/vanilla';
import { atom } from 'jotai/vanilla';
import { DescriptionPanelCollectionContents } from '@view-model/models/sticky/DescriptionPanel/domain/DescriptionPanelCollectionContents';
import { FileContainerCollectionContents } from '@view-model/models/sticky/FileContainer/domain/FileContainerCollectionContents';
import { AnnotationLinkCollection } from '@view-model/models/sticky/AnnotationLink/domain/AnnotationLinkCollection';
import { ModelCommentContents } from '@view-model/models/sticky/ModelComment/domain/ModelCommentContents';
import { ElementDescriptionSet } from '@view-model/models/sticky/ElementDescription';
import { DisplayOrderTree } from '@model-framework/display-order';
import { ModelKey } from '@view-model/domain/key';
import type { StickyZone } from '@view-model/models/sticky/StickyZoneView';
import { PositionSet } from '@view-model/models/common/PositionSet';
import type { StickyNode } from '@view-model/models/sticky/StickyNodeView';
import type { LinkEntity } from '@view-model/models/sticky/StickyLink';
import type { ModelId } from 'balus-common';

export type StickyModelContentsState = {
  panelContents: DescriptionPanelCollectionContents;
  fileContainerContents: FileContainerCollectionContents;
  annotationLinks: AnnotationLinkCollection;
  commentContents: ModelCommentContents;
  nodeDescriptionSet: ElementDescriptionSet;
  zoneDescriptionSet: ElementDescriptionSet;
  displayOrderTree: DisplayOrderTree;
  stickyZones: StickyZone[];
  stickyZonePositions: PositionSet;
  stickyNodes: StickyNode[];
  links: LinkEntity[];
};

export const stickyModelContentsAtomFamily = atomFamily<ModelId, PrimitiveAtom<StickyModelContentsState>>(
  (modelId) => {
    return atom<StickyModelContentsState>({
      panelContents: DescriptionPanelCollectionContents.buildEmpty(),
      fileContainerContents: FileContainerCollectionContents.buildEmpty(),
      annotationLinks: AnnotationLinkCollection.buildEmpty(),
      commentContents: ModelCommentContents.buildEmpty(ModelKey.buildFromID(modelId)),
      nodeDescriptionSet: ElementDescriptionSet.fromArray([]),
      zoneDescriptionSet: ElementDescriptionSet.fromArray([]),
      displayOrderTree: new DisplayOrderTree(),
      stickyZones: [],
      stickyZonePositions: new PositionSet(),
      stickyNodes: [],
      links: [],
    });
  },
  (left, right) => left === right
);
